import { Warning } from "@phosphor-icons/react";

import { AudioPlayer } from "features/voice-message/components";

import useMessageAttachment from "../../../datahooks/useMessageAttachment";

export default function AudioMessage({
  accountId,
  audioUrl,
  duration,
}: {
  accountId: string;
  audioUrl: string;
  duration: number;
}) {
  const { attachmentData, isLoadingAttachmentData, attachmentDataError } =
    useMessageAttachment({
      accountId,
      url: audioUrl,
    });

  if (attachmentDataError) {
    return (
      <div className="flex items-center gap-1">
        <Warning className="text-red-600" />
        <span className="text-sm text-red-600">Failed to load audio</span>
      </div>
    );
  }
  return (
    <AudioPlayer
      audioBlob={attachmentData?.blob}
      initialPlaybackTime={duration ? duration / 1000 : undefined}
      isLoading={isLoadingAttachmentData}
    />
  );
}
